import React from 'react'
import {Link} from 'react-router-dom'

function Useritem({user:{login,avatar_url,html_url}}) {
    
        
        return (
        <div className='card userItem text-center'>
        <img src={avatar_url} alt='img' className='round-img' style={{width:'60px'}}/>
        <h3>{login}</h3>
        <Link to={`/user/${login}`} className="btn btn-dark btn-sm my-1">Profile</Link>
        </div>
        )
    
}

export default Useritem
